/* globals angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('quickFilterEditor', ['$timeout', 'Logger', 'Utils', 'ExplorerUtils', 'QuickFilterEditorModel', 'CustomDateFilter', function ($timeout, Logger, Utils, ExplorerUtils, QuickFilterEditorModel, CustomDateFilter) {
    return {
      restrict: 'EA',
      scope: {
        referenceModel: '=',
        type: '@'
      },
      templateUrl: 'modules/app/quick-filter/quick-filter-editor-partial.html',
      link: function quickFilterEditorLink($scope, $elem, $attrs) {
        Logger.debug("QuickFilterEditor");
        $scope.useLightTheme = Object.keys($attrs).includes('uselighttheme');
        function showPickerType(expectedType) {
          return function (filterType, referenceModelFilters) {
            return expectedType === filterType && referenceModelFilters[filterType].type === 'custom';
          };
        }
        function noFilterProperties(model) {
          return Object.keys(model).length === 0;
        }
        $scope.view = {
          collapsedSections: {
            activities: true,
            people: true,
            verbs: true,
            dates: true
          },
          isCreatingCustomDateFilter: function isCreatingCustomDateFilter() {
            return CustomDateFilter.showCreationView;
          },
          collapseSection: function collapseSection(type, preventSave) {
            this.collapsedSections[type] = true;
            if (!preventSave) {
              QuickFilterEditorModel.saveQuickFilters();
            }
          },
          openSection: function openSection(type) {
            this.collapsedSections[type] = false;
          },
          toggleSection: function toggleSection(type) {
            var isCollapsed = this.collapsedSections[type];
            if (isCollapsed) {
              this.openSection(type);
            } else {
              this.collapseSection(type);
            }
          },
          isSectionCollapsed: function isSectionCollapsed(type) {
            return this.collapsedSections[type];
          }
        };
        $scope.showPeoplePicker = showPickerType('people');
        $scope.showVerbPicker = showPickerType('verbs');
        $scope.showDatePicker = showPickerType('dates');
        $scope.showActivityPicker = showPickerType('activities');
        var stopWatch = $scope.$watch('referenceModel', function (referenceModel) {
          var isLoaded = Object.keys(referenceModel).includes('quickFilters');
          if (isLoaded) {
            if (noFilterProperties(referenceModel.quickFilters)) {
              referenceModel.quickFilters = {
                activities: {
                  type: 'all'
                },
                people: {
                  type: 'all'
                },
                verbs: {
                  type: 'all'
                },
                dates: {
                  type: 'all'
                }
              };
            }
            QuickFilterEditorModel.init(referenceModel);
            $scope.quickFilter = QuickFilterEditorModel.getQuickFilters();
            $scope.getTypeOptions = _.memoize(QuickFilterEditorModel.getTypeOptions($scope.type));
            $scope.onQuickFilterChange = _.memoize(QuickFilterEditorModel.setTypeFor);
            stopWatch(); // Stop watching after init() -- watching is expensive!
          }
        });
      }
    };
  }]);
})(this);
